import React, { useEffect, useState } from "react";
import { useSearchParams, useNavigate, Link } from "react-router-dom";
import api, { formatApiError } from "../api";
import { LogoLight } from "../components/Logo";
import { CheckCircle2, AlertTriangle } from "lucide-react";

export default function AdminTotpReset() {
  const [params] = useSearchParams();
  const nav = useNavigate();
  const token = params.get("token") || "";
  const [state, setState] = useState("loading"); // loading | success | error
  const [error, setError] = useState("");
  const [email, setEmail] = useState("");

  useEffect(() => {
    let cancel = false;
    (async () => {
      if (!token) {
        setError("Lien invalide (token manquant).");
        setState("error");
        return;
      }
      try {
        const { data } = await api.post("/admin/auth/totp/reset/confirm", { token });
        if (cancel) return;
        setEmail(data.email || "");
        setState("success");
      } catch (err) {
        if (cancel) return;
        setError(formatApiError(err));
        setState("error");
      }
    })();
    return () => { cancel = true; };
  }, [token]);

  return (
    <div className="min-h-screen flex items-center justify-center px-6 py-12" style={{ backgroundColor: "var(--auprea-navy)" }}>
      <div className="w-full max-w-md">
        <div className="text-center mb-10">
          <LogoLight size={32} />
        </div>
        <div className="auprea-card">
          {state === "loading" && (
            <div data-testid="reset-2fa-loading" className="text-center py-6">
              <p style={{ fontSize: 15, color: "rgba(35,38,46,0.7)" }}>Réinitialisation en cours…</p>
            </div>
          )}

          {state === "success" && (
            <div data-testid="reset-2fa-success">
              <div className="flex items-center gap-3 mb-3">
                <CheckCircle2 size={28} color="#2f7d5b" />
                <h1 style={{ fontSize: 24, margin: 0 }}>2FA réinitialisée</h1>
              </div>
              <p style={{ color: "rgba(35,38,46,0.75)", lineHeight: 1.6, fontSize: 14 }}>
                Votre authentification à deux facteurs pour <strong>{email}</strong> a été désactivée
                avec succès. Cliquez sur le bouton ci-dessous pour vous reconnecter — vous serez
                automatiquement invité(e) à scanner un nouveau QR code avec votre application
                Authenticator.
              </p>
              <button
                onClick={() => nav("/direction/connexion", { replace: true })}
                className="auprea-btn w-full mt-5"
                data-testid="reset-2fa-go-login"
              >
                Aller à la connexion
              </button>
            </div>
          )}

          {state === "error" && (
            <div data-testid="reset-2fa-error">
              <div className="flex items-center gap-3 mb-3">
                <AlertTriangle size={28} color="#b53a3a" />
                <h1 style={{ fontSize: 22, margin: 0 }}>Lien invalide</h1>
              </div>
              <p style={{ color: "rgba(35,38,46,0.75)", lineHeight: 1.6, fontSize: 14 }}>
                {error || "Ce lien de réinitialisation 2FA est invalide, expiré ou déjà utilisé."}
              </p>
              <p style={{ color: "rgba(35,38,46,0.6)", fontSize: 13, marginTop: 10 }}>
                Les liens sont valables 1 heure et ne fonctionnent qu&apos;une seule fois.
                Demandez un nouveau lien depuis la page de connexion.
              </p>
              <Link to="/direction/connexion" className="auprea-btn w-full mt-5 text-center block" style={{ textDecoration: "none" }} data-testid="reset-2fa-back-login">
                Retour à la connexion
              </Link>
            </div>
          )}
        </div>
        <div className="text-center mt-6" style={{ color: "rgba(243,239,230,0.5)", fontSize: 12 }}>
          AUPREA — Direction · accès journalisé et chiffré
        </div>
      </div>
    </div>
  );
}
